/**
 * Session Tracker
 * Generates and persists a UUID session ID in localStorage for anonymous analytics.
 * Also provides helper to get the authenticated user ID if logged in.
 */

import { supabase } from '../supabaseClient';

const SESSION_KEY = 'ikahata_session_id';

/**
 * Get or create a persistent session ID for anonymous tracking.
 * Stored in localStorage so it survives page refreshes and revisits.
 */
export function getSessionId(): string {
    try {
        let sessionId = localStorage.getItem(SESSION_KEY);
        if (!sessionId) {
            sessionId = crypto.randomUUID();
            localStorage.setItem(SESSION_KEY, sessionId);
        }
        return sessionId;
    } catch {
        // Fallback for environments where localStorage is unavailable
        return `fallback_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    }
}

/**
 * Get the authenticated user's ID, or null if not logged in.
 * Uses cached session to avoid extra network calls.
 */
export async function getAuthUserId(): Promise<string | null> {
    try {
        const { data: { session } } = await supabase.auth.getSession();
        return session?.user?.id ?? null;
    } catch {
        return null;
    }
}
